export function canManageTutorialNode(node, user, { isManager = false } = {}) {
  if (isManager) return true;
  if (!user?.id || !node) return false;
  if (node.ownerId == null) return false;
  return Number(node.ownerId) === Number(user.id);
}

export function canWriteTutorialContent(user) {
  return Boolean(user?.isEditor || user?.isManager);
}
